import * as React from 'react';
import classNames from 'classnames';

import IMPComponent from '../interfaces/IMPComponent';

import './styles.scss';

interface IMagicBallProps extends IMPComponent {
  disabled: boolean;
}

const MagicBall: React.FunctionComponent<IMagicBallProps> = ({ className, disabled, style }) => {
  const cn = classNames('MagicBall', className, {
    'MagicBall--disabled': disabled,
  });

  return (
    <div className={cn} style={style}>
      <div className="MagicBall-image" />
    </div>
  );
};

export default React.memo(MagicBall);



// WEBPACK FOOTER //
// ./src/components/MagicBall/index.tsx